import React from "react";
import Modal from "../../../../components/modal";
import { AcessoPessoa } from "../../../../interfaces/acessos";
import { BTN_SECUNDARIO } from "../../paineis-admin/components/shared";

interface Props {
  pessoa: AcessoPessoa;
  desativando: boolean;
  onConfirmar: () => void;
  onClose: () => void;
}

const BTN_PERIGO =
  "flex items-center justify-center gap-2 rounded-xl bg-red-600 px-5 py-2.5 text-sm font-bold text-white shadow-dv-md transition-all hover:bg-red-700 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50";

/** Confirmação própria (não `window.confirm`): desativar derruba as sessões da pessoa. */
const ConfirmarDesativarModal: React.FC<Props> = ({ pessoa, desativando, onConfirmar, onClose }) => (
  <Modal onClose={onClose}>
    <div
      onClick={(e) => e.stopPropagation()}
      aria-labelledby="desativar-titulo"
      className="w-full max-w-md space-y-4 rounded-[20px] bg-white p-6 shadow-dv-md dark:bg-navy-800"
    >
      <h2 id="desativar-titulo" className="font-display text-lg font-extrabold text-navy-700 dark:text-white">
        Desativar acesso
      </h2>
      <p className="text-sm text-gray-600 dark:text-gray-300">
        {pessoa.nome} ({pessoa.email}) perde o acesso a esta organização e é desconectada. Você pode reativar depois.
      </p>
      <div className="flex justify-end gap-2">
        <button type="button" className={BTN_SECUNDARIO} onClick={onClose}>
          Cancelar
        </button>
        <button type="button" className={BTN_PERIGO} onClick={onConfirmar} disabled={desativando}>
          {desativando ? "Desativando..." : "Desativar"}
        </button>
      </div>
    </div>
  </Modal>
);

export default ConfirmarDesativarModal;
